export default "<div class=\"profile-picture\">\n  <mat-card>\n  </mat-card>\n</div>\n"